var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSetting3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CurrentIconColor2",
    d: "M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM8.17 5.5C8.17 5.09 8.51 4.75 8.92 4.75C9.33 4.75 9.67 5.09 9.67 5.5V9.4C9.67 9.81 9.33 10.15 8.92 10.15C8.51 10.15 8.17 9.81 8.17 9.4V5.5ZM10.0228 16.4313C9.81938 16.5216 9.67 16.7132 9.67 16.9358V18.5C9.67 18.91 9.33 19.25 8.92 19.25C8.51 19.25 8.17 18.91 8.17 18.5V16.9358C8.17 16.7132 8.0206 16.5216 7.81723 16.4311C6.86275 16.0064 6.2 15.058 6.2 13.95C6.2 12.45 7.42 11.22 8.92 11.22C10.42 11.22 11.65 12.44 11.65 13.95C11.65 15.0582 10.9791 16.0066 10.0228 16.4313ZM16.83 18.5C16.83 18.91 16.49 19.25 16.08 19.25C15.67 19.25 15.33 18.91 15.33 18.5V14.6C15.33 14.19 15.67 13.85 16.08 13.85C16.49 13.85 16.83 14.19 16.83 14.6V18.5ZM16.08 12.77C14.58 12.77 13.35 11.55 13.35 10.04C13.35 8.93185 14.0209 7.98342 14.9772 7.55873C15.1806 7.46839 15.33 7.27681 15.33 7.05421V5.5C15.33 5.09 15.67 4.75 16.08 4.75C16.49 4.75 16.83 5.09 16.83 5.5V7.06421C16.83 7.28681 16.9794 7.47835 17.1828 7.56885C18.1372 7.9936 18.8 8.94195 18.8 10.05C18.8 11.55 17.58 12.77 16.08 12.77Z",
    fill: "#586572"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting3);
export default __webpack_public_path__ + "static/media/setting-3.e186cebae246304fe0a73c2411c09ad6.svg";
export { ForwardRef as ReactComponent };